//
// Image Modal/ Gallery functions
//
import { Fancybox } from "@fancyapps/ui";
import Colcade from 'colcade';

export default class ImageGallery {
    constructor() {

        //
        // FancyBox
        //
        // Bind Fancybox to all Elements with the data-fancybox attribute
        Fancybox.bind("[data-fancybox]", {

        });

        //
        // Colcade (Masonry)
        //
        // Initialise Colcade JS if present, else quit out now
        const colcadeElement = document.querySelector(".js-colcade");
        if (!colcadeElement) return;

        // Bind Colcade JS to colcade elements
        var colc = new Colcade('.js-colcade', {
            columns: '.js-colcade-col',
            items: '.js-colcade-item'
        });
    }
}